import {PersonnelDTO} from '@/types/gatewayDataModels';

// Test request type. Replace with the approved production configuration before release.
const supportRequestConfig = {
    url: 'https://dispatchhealth.atlassian.net/servicedesk/customer/portal/256/create/2680',
    fullNameField: 'customfield_11162',
    customerField: 'customfield_11405',
    customers: {
        'cesia-qa': '16923',
        'Boston Medical Center': '12573',
        'Christiana Care': '12576',
        'Cleveland Clinic Florida': '12574',
        'Covenant Health': '12577',
        'Cedars-Sinai Health System': '12575',
        'Hackensack Meridian Health': '12578',
        'OSF HealthCare': '12598',
        'St. Lukes Boise': '12600',
    } as Record<string, string>,
};

const buildSupportRequestUrl = (
    employment: Pick<PersonnelDTO, 'firstName' | 'lastName'>,
    missionControlName?: string,
) => {
    const {url, fullNameField, customerField, customers} = supportRequestConfig;
    const target = new URL(url);
    const fullName = [employment.firstName?.trim(), employment.lastName?.trim()].filter(Boolean).join(' ');
    if (fullName) target.searchParams.set(fullNameField, fullName);

    if (missionControlName && Object.prototype.hasOwnProperty.call(customers, missionControlName)) {
        const customer = customers[missionControlName];
        if (customer) target.searchParams.set(customerField, customer);
    }

    return target.toString();
};

export {buildSupportRequestUrl};
